
<div class="wrapper">
    <div class="container px-0">
            <h5 class="main-title">{{patientPersonalInfo.PracticeName || 'N/A'}}</h5>
            <div class="main-info pb-3">COVID Form</div>
        <div class="form-group pt-3">
            <p class="mb-2  font-weight-bold">Please describe your visit reason<span class="required">*</span></p>
            <textarea [(ngModel)]="sympTomsModel!.visitReason" #VR="ngModel" class="form-control text-capitalize" placeholder="Enter your reason"></textarea>
            <span *ngIf="visiReasonError || (VR.touched && VR.value.length < 1)" class="err">Visit reason is required.</span>
        </div>
        <div class="form-group">
            <p class="mb-2  font-weight-bold">Have you experienced any of the following symptoms recently?<span class="required">*</span></p> 
            <ul class="list-unstyled mb-0 new-symptoms-list row">
                <li *ngFor="let s of checklist; let i = index " class="col-sm-6 col-lg-4">
                    <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" [(ngModel)]="s.isSelected" (change)="disableOthers($event)" type="checkbox" value="{{s.label}}" id="{{s.id}}">
                        <label class="custom-control-label" for="{{s.id}}">
                            {{s.label}}
                        </label>
                    </div>
                </li>
                <li class="col-12">
                    <span *ngIf="recentSymptomsError" class="err">Reccent symptom is required.</span>
                </li>
            </ul>
        </div>
        <div class="form-group">
            <p class="mb-2 font-weight-bold">Have you been in contact with anyone diagnosed or suspected of COVID-19?<span class="required">*</span></p>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input"  (change)="radioBoxChange($event)" type="radio" name="exampleRadios" id="yes1" value="suspectedYes">
                <label class="custom-control-label" for="yes1">
                    Yes
                </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input"  (change)="radioBoxChange($event)" type="radio" name="exampleRadios" id="no1" value="suspectedNo">
                <label class="custom-control-label" for="no1">
                    No
                </label>
            </div>
            <p><span *ngIf="diagnosedOrSuspectedError" class="err">Please choose an option (YES/NO).</span></p>
        </div>
        <div class="form-group">
            <p class="mb-2 font-weight-bold">Have you travelled outside of NJ in last two weeks?<span class="required">*</span></p>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input"  (change)="radioBoxChange($event)" type="radio" name="exampleRadios2" id="exampleRadios1" value="travelledYes">
                <label class="custom-control-label" for="exampleRadios1">
                    Yes
                </label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input"  (change)="radioBoxChange($event)" type="radio" name="exampleRadios2" id="exampleRadios2" value="travelledNo">
                <label class="custom-control-label" for="exampleRadios2">
                    No
                </label>
            </div>
            <p><span *ngIf="travelOutSideError" class="err">Please choose an option (YES/NO).</span></p>
        </div>
    </div>
</div>

<footer class="p-3">
    <div class="container p-0">
        <div class="d-flex justify-content-between align-items-center">
            <button class="btn btn-outline-primary" type="button" (click)="backClick()">Back</button>
            <p class="mb-0">({{pageNum}} of {{totalPages}})</p>
            <button class="btn btn-primary" type="button" (click)="SaveCovidQuestionire()">Finish</button>
        </div>
    </div>
</footer>